import { render, staticRenderFns } from "./NewEditFichaDiarioAtendimento.vue?vue&type=template&id=9e879948"
import script from "./NewEditFichaDiarioAtendimento.vue?vue&type=script&lang=js"
export * from "./NewEditFichaDiarioAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports